export default "__VITE_ASSET__ClFhaKTE__";